module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-center-7bedb3e95df308971baf663254ee06fd.svg";